<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          v-show="false"
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="zoneFilter" 
        filterKey="zoneID"
        v-bind:filterEmptyMessage="'No car park zone data available'"
        v-on:filter-data-change="onFilterZoneChange" />

      <div 
        v-if="pageTenant && pageSeason && pageEntitlement"
        class="col-12 table-responsive">

        <table 
          class="table table-bordered">

          <tr>
            <th>No.</th>
            <th>Customer</th>
            <th>Total Entitlement</th>
            <th 
            v-for="season in pageSeason"
            v-bind:key="season.id">
            {{ season.name }}
            </th>
          </tr>

          <tr 
            v-for="(tenant, index) in pageTenant"
            v-bind:key="tenant.id">
            <td v-html="index + 1"></td>
            <td v-html="tenant.name + '<br>' + tenant.nationalID"></td>
            <td>{{ totalCustomerEntitle[tenant.customerID] || 0 }}</td>
            <td 
            v-for="season in pageSeason"
            v-bind:key="season.id">
            <!-- {{ tenant.customerID + '_' + season.id }} -->
            <button 
              class="baycount-btn btn btn-sm btn-rounded" 
              style="min-width: 45px; background-color: #C9A12F; color: #fff" 
              v-on:click="onTenantBayCountClick(tenant, season)">
            {{ totalCustomerSeasonEntitle[tenant.customerID + '_' + season.id] || 0 }}
            </button>
            <button 
              class="baycount-btn btn btn-sm btn-rounded" 
              style="min-width: 45px; background-color: #C9A12F; color: #fff" >
            Used Bay: {{ totalCustomerSeasonEntitleUsed[tenant.customerID + '_' + season.id] || 0 }}
            </button>
            <button 
              class="baycount-btn btn btn-sm btn-rounded" 
              style="min-width: 45px; background-color: #C9A12F; color: #fff" >
            Avai. Bay: {{ totalCustomerSeasonEntitleAvailable[tenant.customerID + '_' + season.id] || 0 }}
            </button>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Total</td>
            <td>{{ totalEntitle }}</td>
            <td 
              v-for="season in pageSeason"
              v-bind:key="'sum_' + season.id">
              {{ totalSeasonEntitle[season.id] || 0 }}
            </td>
          </tr>

        </table>

      </div>

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: 'bayCount',
    text: 'Entitlement Bay Count',
    form_input_attr: {
      'type': 'Number',
    },
  },
];

export default {
  name: "PageEntitlement",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Entitlement' },
      ],

      PARAM,

      pageSeason: null,
      pageCustomer: null,
      pageTenant: null,
      pageEntitlement: null,

      totalEntitle: 0,

      totalCustomerEntitle: {},
      totalSeasonEntitle: {},
      totalCustomerSeasonEntitle: {},
      totalCustomerSeasonEntitleUsed: {},
      totalCustomerSeasonEntitleAvailable: {},
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageModal'].modalCanDelete = false;
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadCustomer();
  },
  methods: {
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer data...');

      let url = helper.SERVER_URL + '/api2/customer/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageCustomer = response.data;
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No customer data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer data'));
        })
    },
    loadCarpark() {
      this.$refs['carparkFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          if(response.data && response.data.length > 0) {
            this.loadZone();
          }
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZone() {
      this.$refs['zoneFilter'].setFilterLoading('Loading zone data...');

      let url = helper.SERVER_URL + '/api2/zone';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url = helper.SERVER_URL + `/api2/carpark/${carparkFilter}/zone`;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['zoneFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.zoneID);
          if(response.data && response.data.length > 0) {
            this.loadTenant();
          }
        })
        .catch(error => {
          this.$refs['zoneFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'zone data'));
        });
    },
    loadTenant() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading tenant data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/tenant/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            if(this.$refs['carparkFilter'].filterValue) {
              response.data = response.data.filter(k => helper.compareID(k['carparkID'], this.$refs['carparkFilter'].filterValue));
            }
            response.data.forEach(k => {
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID) || {};
              if(k['_customer'].isCompany) {
                k['name'] = `<a target="_blank" href="companyForm?customerID=${k['_customer'].id}">${k['_customer'].name}</a>`;
              } else {
                k['name'] = `<a target="_blank" href="personalForm?customerID=${k['_customer'].id}">${k['_customer'].name}</a>`;
              }
              k['nationalID'] = k['_customer'].nationalID;
            });
            this.pageTenant = response.data;
            this.loadSeason();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No tenant data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        })
    },
    loadSeason() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading entitlement product data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
        if(this.$refs['zoneFilter'].filterValue) {
          url += '/zone/' + this.$refs['zoneFilter'].filterValue;
        }
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data = response.data.filter(k => k.entitleOnly);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadBay();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No entitlement product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'entitlement product data'));
        })
    },
    loadBay() {
      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
        let zoneFilter = this.$refs['zoneFilter'].filterValue;
        if(zoneFilter) {
          url += '&zoneID=' + zoneFilter;
        }
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageBay = response.data;
            this.loadEntitlement();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadEntitlement() {
      this.pageEntitlement = null;

      this.$refs['pageFeedback'].setFeedbackLoading('Loading entitlement data...');

      let url = helper.SERVER_URL + '/api2';
      // if(this.$refs['carparkFilter'].filterValue) {
      //   url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      //   if(this.$refs['zoneFilter'].filterValue) {
      //     url += '/zone/' + this.$refs['zoneFilter'].filterValue;
      //   }
      // }
      url += '/entitlement/';
      if(this.$refs['zoneFilter'].filterValue) {
        url += '?zoneID=' + this.$refs['zoneFilter'].filterValue;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);

      // let url = helper.SERVER_URL + '/api2/entitlement/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageEntitlement = response.data || [];

          this.totalEntitle = 0;
          this.totalCustomerEntitle = {};
          this.totalSeasonEntitle = {};
          this.totalCustomerSeasonEntitle = {};
          this.totalCustomerSeasonEntitleUsed = {};
          this.totalCustomerSeasonEntitleAvailable = {};

          this.pageEntitlement.forEach(k => {
            this.totalCustomerEntitle[k.customerID] = (this.totalCustomerEntitle[k.customerID] || 0) + k.bayCount;
            this.totalSeasonEntitle[k.seasonID] = (this.totalSeasonEntitle[k.seasonID] || 0) + k.bayCount;
            this.totalCustomerSeasonEntitle[k.customerID + '_' + k.seasonID] = k.bayCount;
            this.totalCustomerSeasonEntitleUsed[k.customerID + '_' + k.seasonID] = this.pageBay.filter(j => j.leaseID && j.seasonID === k.seasonID && j.customerID === k.customerID).length;
            this.totalCustomerSeasonEntitleAvailable[k.customerID + '_' + k.seasonID] = this.totalCustomerSeasonEntitle[k.customerID + '_' + k.seasonID] - this.totalCustomerSeasonEntitleUsed[k.customerID + '_' + k.seasonID];
            this.totalEntitle += k.bayCount;
          });
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'entitlement data'));
        })
    },
    
    findEntitlement(tenant, season) {
      return this.pageEntitlement.find(k => k.tenantID === tenant.id && k.seasonID === season.id) || {};
    },

    onTenantBayCountClick(tenant, season) {
      let total = 0;
      let entitlement = this.findEntitlement(tenant, season);
      entitlement.tenant = tenant;
      entitlement.season = season;
      this.$refs['pageModal'].setModalOpen(false, `Entitlement for ${tenant.name} - ${season.name}` , entitlement);
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      // this.$refs['pageTable'].setCurrentPage(1);
      this.loadEntitlement();
    },
    onFilterCarparkChange(dataIndex) {
      // this.$refs['pageTable'].setCurrentPage(1);
      this.pageTenant = null;
      this.pageSeason = null;
      this.pageEntitlement = null;
      this.loadZone();
    },
    onFilterZoneChange(dataIndex) {
      // this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageEntitlement = null;
      this.loadSeason();
    },

    onModalAddDataClick(selectedData) {
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading(`Setting entitlement for ${selectedData.tenant.name} - ${selectedData.season.name}`);
      
      let url = helper.SERVER_URL + '/api2';

      let method;
      // if(selectedData.id) {
      //   method = this.$http.put;

      //   // url += '/entitlement/' + selectedData.id;
      //   url += '/season/' + selectedData['seasonID'] + '/entitlement/' + selectedData.id;
      // } else {
      //   method = this.$http.post;

      //   selectedData['seasonID'] = selectedData.season.id;
      //   selectedData['tenantID'] = selectedData.tenant.id;

      //   let customer = this.pageCustomer.find(k => k.id === selectedData.tenant.customerID);
      //   selectedData['name'] = customer.name;

      //   // url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      //   // if(customer.isCompany) {
      //   //   url += '/companyentitlements/';
      //   // } else {
      //   //   url += '/personalentitlements/';
      //   // }
      //   url += '/season/' + selectedData['seasonID'] + '/entitlement/';
      // }

      method = this.$http.post;
      selectedData['seasonID'] = selectedData.season.id;
      selectedData['tenantID'] = selectedData.tenant.id;
      url += '/season/' + selectedData['seasonID'] + '/entitlement/';

      method(
          url,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageModal'].setModalClose();

          this.$refs['pageFeedback'].setFeedbackMessage('Successfully set entitlement');
          this.loadEntitlement();
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', 'entitlement'));
        })
    },
    onModalDeleteDataClick(selectedData) {
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageEntitlement.vue